import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import GoogleSignIn from './GoogleSignIn';
import Title from './dev/Title';
import Input from './dev/Input'
import Submit from './dev/Submit';
import Response from './dev/Response';
import { fromEvent } from 'rxjs'
import { debounceTime } from 'rxjs/operators';
import LoadingSpinner from '../dev/LoadingSpinner';

const { REACT_APP_URI = '/' } = process.env
class SignIn extends Component {
    state={
        isLoading: false,
        isEmailExsit: '',
        response: '',
    }
    componentDidMount() {
        if(document.querySelector('#singInObservableInput') !== null) {
            const email = document.querySelector('#singInObservableInput').value
            if( email !== "") {
                this.checkEmailExsit(email);
            }
            this.observeEmailInput()
        }
    }
    checkEmailExsit = email => {
        const { token } = this.props.user
        if (this.props.isEmail(email)) {
            fetch(`${REACT_APP_URI}/accounts/emailCheck/`, {
                method: 'post',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRFToken": token,
                },
                body: JSON.stringify({ email: email })
            })
            .then(res => {
                if (res.status === 200) return this.setState({ isEmailExsit: false })
                if (res.status === 400) return this.setState({ isEmailExsit: true })
            })
        }
    }
    observeEmailInput = () => {
        const { checkEmailExsit } = this
        const observable = fromEvent(document.querySelector('#singInObservableInput'), "input")
        observable
            .pipe(debounceTime(500))
            .subscribe(e => {
                const { target: { value } } = e;
                if (value === '' && document.querySelector('#singInObservableInput').value === "") this.setState({ isEmailExsit: false })
                else {checkEmailExsit(value)}
            })
            
    }
    render() {
        const { user: { email, password, token }, messages, isEmail } = this.props 
        const { response, isLoading, isEmailExsit } = this.state
        const profileInput = condition => e => this.props.dispatch({ type: `${condition}Input`, [condition]: e.target.value })
        const profileSubmit = (e) => {
            e.preventDefault();
            if (isButtonActive() === 'disabled') return
            this.setState({ isLoading: true })
            fetch(`${REACT_APP_URI}/accounts/login/`, {
                method: 'post',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRFToken": token,
                },
                body: JSON.stringify({ email: email, password: password })
            })
            .then(res => {
                const { status } = res
                if (status === 200) { this.setState({ response: '', isLoading: false }); return res.json()};
                if (status === 400) throw this.setState({ response: messages.user_invalid_account_or_password, isLoading: false });
                if (status === 605) throw this.setState({ response: messages.user_account_not_verifiied, isLoading: false});
                //if (status === 608) throw this.setState({ response: '由於加密方式變更，舊會員請點選下方「忘記密碼」重設密碼', isLoading: false});
            })
            .then(res => this.props.dispatch({ type: 'setToken', token: res.token }))
            .then(() => window.location.reload())
        }
        const isButtonActive = () => {
            if (isEmail(email) && password !== '' && isEmailExsit) return ''
            else return 'disabled'
        }
        return (
            <Container>
                <React.Fragment>
                    <Title>{messages.nav_user_login}</Title>
                    <GoogleSignIn />
                    <form>
                        <Input
                            id="singInObservableInput"
                            onInput={profileInput('email')} value={email}
                            onKeyPress={e => e.key === "Enter" && profileSubmit()}
                            type="text" name="username" placeholder={`E-mail ${messages.member_account} `} autoFocus autoComplete="on"
                        />
                        {!isEmail(email) && email !== '' && <Response>{messages.user_correct_email_format}</Response>}
                        {(!isEmailExsit && isEmailExsit !== '') && <Response>{messages.user_account_not_exist}</Response>}
                        <Input
                            onInput={profileInput('password')} value={password}
                            onKeyPress={e => e.key === "Enter" && profileSubmit()}
                            type="password" name="password" placeholder={messages.nav_password}
                        />
                        <Submit type="submit" onClick={profileSubmit} disabled={isButtonActive()}>{messages.nav_login}</Submit>
                    </form>
                    {response !== '' && <Response>{response}</Response>}
                    {isLoading && <LoadingSpinner/>}
                    {/* 要做驗證信判斷 */}
                </React.Fragment>
                <Footer>
                    <div onClick={() => this.props.dispatch({ type: 'changeUserCondition', condition: 'forgetPassword' })}>{messages.user_forget_password}</div>
                    <SignUp id={'ga_signup'} onClick={() => this.props.dispatch({ type: 'changeUserCondition', condition: 'register' })}>{messages.user_fast_signup}</SignUp>
                </Footer>
            </Container>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(SignIn));
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-height: 270px;
`
const Footer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 14px;
    font-weight: 300;
    div {
        cursor: pointer;
        &:nth-child(1){
            padding-right: 10px;
        }
        &:nth-child(2){
            padding-left: 10px;
        }
    }
`
const SignUp = styled.div`
    color: #de0606;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/User/SignIn.js